export class QuarterMetric {
    constructor(params) {
        this.year = params.year;
        this.quarter = params.quarter;
        this.value = params.value;
        this.unit = params.unit;
    }
}

export class QuarterTaxMetric {
    constructor(params) {
        this.year = params.year;
        this.quarter = params.quarter;
        this.fedValue = params.fedValue;
        this.regValue = params.regValue;
        this.unit = params.unit;
    }
}

